// DOMContentLoadedで確実に要素が読み込まれてから処理を実行
document.addEventListener('DOMContentLoaded', function() {
  var splides = document.querySelectorAll('.splide__01');
  
  splides.forEach(function (splideElement) {
    // 初期化前はCSSで制御するため、インラインスタイルは設定しない
    
    var splide = new Splide(splideElement, {
      autoplay: false, // 自動再生
      type: "slide",
      pagination: false,
      focus: "left",
      pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
      pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
      interval: 2000, // 自動再生の間隔
      speed: 1000, // スライダーの移動時間
      perPage: 6,
      padding: "5rem", // スライダーの左右の余白
      gap: 20, // スライド間の余白
      arrows: false, // 矢印ボタンを非表示
      breakpoints: {
        950: {
          perPage: 5, // 500px未満の表示枚数
          padding: "5rem", // スライダーの左右の余白
          gap: 20, // スライド間の余白
        },
        749: {
          perPage: 4, // 500px未満の表示枚数
          padding: "1.5rem", // スライダーの左右の余白
          gap: 20, // スライド間の余白
        },
        550: {
          perPage: 3, // 500px未満の表示枚数
          padding: { left: "1.5rem", right: 20 }, // スライダーの左右の余白
          gap: 10, // スライド間の余白
        },
        450: {
          perPage: 3, // 500px未満の表示枚数
          padding: { left: "1.5rem", right: 20 }, // スライダーの左右の余白
          gap: 10, // スライド間の余白
        },
      },
    });

    // マウント前にイベントリスナーを設定
    splide.on('mounted', function () {
      // loadingクラスを削除
      splideElement.classList.remove('loading');
      // 初期化完了クラスを追加
      splideElement.classList.add('is-initialized');
    });

    // Splideをマウント
    splide.mount();
  });
});